<template>
    <div class="main-block request-management">
        <Breadcrumbs :isCheck="true" @navigate="handleNavigation" />
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.addIntegrations') }}</h4>
        </div>
        <section class="col-12 mx-auto align-self-md-center scrollable-block">
            <div class="half-design row">
                <div class="col-12 form-block">

                    <div class="col-12 col-md-6 col-lg-5 mx-auto pt-5">
                        <b-form @submit.prevent="onSubmit" enctype="multipart/form-data">
                            <!-- for selecting service  -->
                            <div class="mb-3 text-left">
                                <label class="mb-1" :class="serviceState" for="typeSelect">
                                    {{ $t('title.Please_select_your_service') }}
                                </label>
                                <v-select id="type-select" v-model="formFields.typeSelect" @input="handleServiceChange"
                                    :options="serviceOptions" label="label"></v-select>

                                <b-form-invalid-feedback :state="!formErrors.has('typeSelect')">
                                    {{ formErrors.first('typeSelect') }}
                                </b-form-invalid-feedback>
                            </div>
                            <div class="mb-3 text-left">
                                <label for="name" class="mb-1" :class="nameState">{{
                                    $t('title.Please_enter_your_organization_name') }}</label>
                                <b-form-input id="name" type="text" v-model="formFields.name"
                                    :placeholder="$t('title.Please_enter_your_organization_name')" @input="validateName"
                                    :class="nameState"></b-form-input>

                                <b-form-invalid-feedback :state="!formErrors.has('name')">
                                    {{ formErrors.first('name') }}
                                </b-form-invalid-feedback> <!-- Show error message -->
                            </div>

                            <!-- Summary Description Field -->
                            <div class="mb-3 text-left">
                                <label for="summary_description" class="mb-1" :class="summaryDescriptionState">
                                    {{ $t('title.Summary_Description') }}
                                </label>
                                <b-form-textarea id="summary_description" v-model="formFields.summary_description"
                                    :placeholder="$t('title.Please_enter_summary_description')" rows="3"
                                    :class="summaryDescriptionState" @input="validateSummaryDescription">
                                </b-form-textarea>

                                <b-form-invalid-feedback :state="!formErrors.has('summary_description')">
                                    {{ formErrors.first('summary_description') }}
                                </b-form-invalid-feedback>
                            </div>

                            <div v-for="(label, key) in dynamicFields" :key="key" class="mb-3 text-left">
                                <label :for="label" class="mb-1">
                                    {{ $t(`title.${label}`) }}
                                </label>
                                <b-input-group
                                    v-if="label !== 'google_service_account_credentials_json' && label !== 'product_service'">
                                    <b-form-input :id="String(label)" v-model="formFields[label]"
                                        :type="passwordVisibility[label] ? 'text' : 'password'"
                                        :placeholder="$t(`title.${label}`)"></b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="toggleVisibility(label)" variant="light">
                                            <b-icon :icon="passwordVisibility[label] ? 'eye-slash' : 'eye'"></b-icon>
                                        </b-button>
                                    </b-input-group-append>
                                </b-input-group>

                                <v-select v-else-if="label === 'product_service'" :id="String(label)"
                                    v-model="formFields[label]"
                                    :placeholder="$t(`title.${label}`, { defaultValue: label })"
                                    :options="productsServicesOptions" label="label" />

                                <b-form-file v-else :id="String(label)"
                                    v-model="formFields.google_service_account_credentials_json"
                                    :placeholder="$t(`title.${label}`)"></b-form-file>


                                <b-form-invalid-feedback :state="!formErrors.has(label)">
                                    {{ formErrors.first(label) }}
                                </b-form-invalid-feedback>
                            </div>


                            <!-- status  -->
                            <div class="mb-3 text-left">
                                <label for="status" class="mb-1" :class="statusState">
                                    {{ $t('title.SelectStatus') }}
                                </label>
                                <v-select id="status" v-model="formFields.status" @input="validateStatus"
                                    :class="statusState" :options="statusOptions" size="sm" required></v-select>

                                <b-form-invalid-feedback :state="!formErrors.has('status')">
                                    {{ formErrors.first('status') }}
                                </b-form-invalid-feedback>
                            </div>
                            <div class="mb-3 text-left">
                                <label for="limit" class="mb-1" :class="statusLimit">
                                    {{ $t('title.SelectLimit') }}
                                </label>
                                <b-form-datepicker id="date_picker" v-model="formFields.selected_date" reset-button
                                    today-button locale="en" class="w-100">
                                </b-form-datepicker>
                                <b-form-invalid-feedback :state="!formErrors.has('limit')">
                                    {{ formErrors.first('limit') }}
                                </b-form-invalid-feedback>
                            </div>

                            <b-button type="submit" variant="primary" class="mb-3 w-100" :disabled="loader">
                                <div class="spinner-border spinner-border-sm text-light" role="status" v-if="loader">
                                </div>
                                {{ $t('title.Submit') }}
                            </b-button>
                            <div class="d-flex gap-2">
                                <b-button type="button" variant="secondary" class="mb-3 col" @click.prevent="resetForm">
                                    {{ $t('title.clear') }}
                                </b-button>
                                <b-button type="button" variant="danger" class="mb-3 col" @click.prevent="onCancel">
                                    {{ $t('title.cancel') }}
                                </b-button>
                            </div>
                        </b-form>
                    </div>
                </div>
            </div>
            <InputChangeConfirmationModal ref="inputChangeConfirmationModal" @back="goBackToDestination"/>
        </section>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { reactive } from 'vue';
import { request } from "@/Util/Request";
import Error from "@/Util/Error";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import InputChangeConfirmationModal from "../modal/InputChangeConfirmationModal";


export default {



    data() {
        return {
            formFields: reactive({
                name: '',
                summary_description: '',
                selected_date: null,
                typeSelect: { value: '', label: this.$t('title.Please_select_your_service') },
                status: { value: '1', label: this.$t('title.Active') },
            }),
            formErrors: new Error({}),
            serviceOptions: [],
            statusOptions: [
                { label: this.$t('title.SelectStatus'), value: null },
                { label: this.$t('title.Active'), value: '1' },
                { label: this.$t('title.Inactive'), value: '0' },
            ],
            dynamicFields: {},
            allProductServicesOptions: {
                salesforce: [
                    { label: this.$t('title.CRM'), value: 'CRM' },
                    { label: this.$t('title.Analytics'), value: 'Analytics' },
                    { label: this.$t('title.Net_Zero_Cloud'), value: 'Net Zero Cloud' },
                    { label: this.$t('title.Financial_Services_Cloud'), value: 'Financial Services Cloud' },
                    { label: this.$t('title.Communications_Cloud'), value: 'Communications Cloud' },
                    { label: this.$t('title.Education_Cloud'), value: 'Education Cloud' },
                ],
                zoho: [
                    { label: this.$t('title.Zoho_CRM'), value: 'CRM' },
                ],
            },
            defaultDate: new Date(),
            passwordVisibility: {},
            originalForm: {},
            isFormDirty: false,
            nextRoute: ''
        };
    },
    components: { Breadcrumbs, InputChangeConfirmationModal },
    computed: {
        ...mapGetters(['loader']),
        productsServicesOptions() {
            // If a service is selected, check if it matches Salesforce or Zoho
            if (!this.formFields.typeSelect) {
                return [];
            }
            const selectedServiceName = this.formFields.typeSelect.label.toLowerCase();
            if (selectedServiceName.includes('salesforce')) {
                return this.allProductServicesOptions.salesforce;
            } else if (selectedServiceName.includes('zoho')) {
                return this.allProductServicesOptions.zoho;
            }
            return [];
        },
        nameState() {
            return this.formFields.name === '' ? '' : this.formErrors.$errors.name ? 'is-invalid' : 'is-valid';
        },
        summaryDescriptionState() {
            return this.formFields.summary_description === '' ? '' : this.formErrors.$errors.summary_description ? 'is-invalid' : 'is-valid';
        },
        statusState() {
            return this.formFields.status === null ? '' : this.formErrors.status ? 'is-invalid' : 'is-valid'; // Add computed for status
        },
        statusLimit() {
            return this.formFields.limit === null ? '' : this.formErrors.limit ? 'is-invalid' : 'is-valid'; // Add computed for status
        },
        serviceState() {
            return this.formFields.typeSelect === '' ? '' : this.formErrors.$errors.typeSelect ? 'is-invalid' : 'is-valid';
        },
    },

    methods: {
        goBackToDestination() {
            if(this.nextRoute) {
                this.$router.push(this.nextRoute);
            }
        },
        handleNavigation(crumb) {
            if (this.isFormDirty) {
                this.$refs['inputChangeConfirmationModal'].handleToggleModal();
                this.nextRoute = crumb.path; // Store next route
            } else {
                this.$router.push(crumb.path); // Navigate if no unsaved changes
            }
        },
        markAsDirty() {
            this.isFormDirty = true;
        },
        checkForChanges() {
            this.isFormDirty = JSON.stringify(this.formFields) !== JSON.stringify(this.originalForm);
        },
        resetForm() {
            this.formFields = reactive({
                name: '',
                summary_description: '',
                selected_date: null,
                typeSelect: { value: '', label: this.$t('title.Please_select_your_service') },
                status: { value: '1', label: this.$t('title.Active') },
            });
        },
        initializeVisibility() {
            Object.keys(this.formFields).forEach((key) => {
                if (!(key in this.passwordVisibility)) {
                    this.$set(this.passwordVisibility, key, false);
                }
            });
        },
        toggleVisibility(field) {
            this.passwordVisibility[field] = !this.passwordVisibility[field];
        },
        async fetchServices() {
            try {
                const response = await request({ method: 'get', url: `/admin/services` });

                this.serviceOptions = response.data.map(service => ({
                    value: service.id,
                    label: service.name,
                    fields: service.fields || {}
                }));

            } catch (error) {
                console.error('Error fetching services:', error);
            }
        },



        handleServiceChange(selectedService) {
            this.dynamicFields = selectedService?.fields || {};
        },


        // Validate the Service Selection
        validateName() {
            const organizationName = this.formFields.name;
            if (typeof organizationName !== 'string') {
                this.formErrors.$errors.name = [this.$t('title.organizationNameRequired')];
                return;
            }
            if (!organizationName || organizationName.trim().length < 3) {
                this.formErrors.$errors.name = [this.$t('title.organizationNameMinLength')];
            } else {
                delete this.formErrors.$errors.name;
            }
        },

        validateSummaryDescription() {
            const summaryDescription = this.formFields.summary_description;
            if (typeof summaryDescription !== 'string') {
                this.formErrors.$errors.summary_description = [this.$t('title.summaryDescriptionRequired')];
                return;
            }
            if (!summaryDescription || summaryDescription.trim().length < 10) {
                this.formErrors.$errors.summary_description = [this.$t('title.summaryDescriptionMinLength')];
            } else {
                delete this.formErrors.$errors.summary_description;
            }
        },

        validateStatus() {
            const status = this.formFields.status;
            if (!status) {
                this.formErrors.$errors.status = [this.$t('title.statusRequired')]; // Add custom error for status
            } else {
                delete this.formErrors.$errors.status;
            }
        },

        validateService() {
            const typeSelect = this.formFields.typeSelect;

            if (!typeSelect.value) {
                this.formErrors.$errors.typeSelect = [this.$t('title.serviceRequired')];
            } else {
                delete this.formErrors.$errors.typeSelect;
            }
        },
        reloadPage() {
            window.location.reload();
        },

        async onSubmit() {
            let formData = new FormData();
            console.log(this.formFields);
            // Manually construct the payload, including all dynamic fields
            formData.append("name", this.formFields.name || "");
            formData.append("summary_description", this.formFields.summary_description || "");
            formData.append("services_id", this.formFields.services_id || this.formFields.typeSelect?.value || "");
            formData.append("is_active", this.formFields.status === "InActive" ? 0 : 1);
            formData.append("limit", this.formFields.selected_date || "");

            // Loop through the dynamic fields and add them to the FormData
            Object.keys(this.formFields).forEach((key) => {
                if (key !== "status" && key !== "typeSelect" && key !== "product_service") {
                    if (key === "google_service_account_credentials_json" && this.formFields[key]) {
                        // Append file instead of converting it to JSON
                        formData.append(key, this.formFields[key]);
                    } else {
                        formData.append(key, this.formFields[key] || "");
                    }
                }
            });

            if (this.formFields.product_service) {
                formData.append("product_service", this.formFields.product_service.value);
            }


            // Make the API call
            try {
                const response = await request({
                    method: "post",
                    url: "/admin/integrations",
                    data: formData,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                // Handle success response
                if (response["message"] && response["message"].includes("successfully")) {
                    this.showToast();
                    setTimeout(() => {
                        this.$router.push({ name: "Integrations" });
                    }, 1000);
                } else {
                    throw new Error(response.message || "Error submitting form");
                }
            } catch (error) {
                this.formErrors = new Error({});
                if (error?.data?.errors) {
                    this.formErrors.$errors = error.data.errors;
                } else {
                    this.formErrors.general = "Something went wrong. Please try again.";
                }
            }
        },



        showToast() {
            const h = this.$createElement;
            const vNodesMsg = h('p', { class: ['text-center', 'mb-0'] }, [
                this.$t('title.dataSaved')
            ]);
            // Create the title
            const vNodesTitle = h(
                'div',
                { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] },
                [h('strong', { class: 'mr-2' }, this.$t('title.dataSavedTitle'))]
            );
            // Pass the VNodes as an array for message and title
            this.$bvToast.toast([vNodesMsg], {
                title: [vNodesTitle],
                solid: true,
                variant: 'success',
            });
        },

        onCancel() {
            this.$router.push({ name: 'Integrations' });
        },
    },
    watch: {
        formFields: {
            deep: true,
            handler() {
                this.initializeVisibility(); // Ensure visibility state is updated when new fields are added
                this.checkForChanges();
            }
        }
    },
    created() {
        this.fetchServices(); // Fetch services when component loads
        this.initializeVisibility();
        this.originalForm = { ...this.formFields };
    },
};
</script>
